import {GameJackpotValueMrGreenBox} from "./game-jackpot-value.mrgreen.box";

export const GameJackpotValueMrGreenCisBox = GameJackpotValueMrGreenBox